/**
 * ZoneSeatSummary Service
 * 구역별 좌석 현황 비즈니스 로직
 */
import { ZoneSummary, OverallSeatStats } from '../models/ZoneSeatSummary';

export class ZoneSeatSummaryService {
  /**
   * 점유율 색상 반환
   */
  getOccupancyColor(rate: number): string {
    if (rate >= 90) return 'text-red-600 bg-red-100';
    if (rate >= 70) return 'text-orange-600 bg-orange-100';
    if (rate >= 50) return 'text-yellow-600 bg-yellow-100';
    return 'text-green-600 bg-green-100';
  }

  /**
   * 점유율 상태 텍스트 반환
   */
  getOccupancyStatus(rate: number): string {
    if (rate >= 90) return '만석 임박';
    if (rate >= 70) return '혼잡';
    if (rate >= 50) return '보통';
    return '여유';
  }

  /**
   * 점유율 바 색상 반환
   */
  getOccupancyBarColor(rate: number): string {
    if (rate >= 90) return 'bg-red-500';
    if (rate >= 70) return 'bg-orange-500';
    if (rate >= 50) return 'bg-yellow-500';
    return 'bg-green-500';
  }

  /**
   * 구역 타입 라벨 반환
   */
  getZoneTypeLabel(zoneType?: string): string {
    if (!zoneType) return '일반 구역';
    const labels: Record<string, string> = {
      premium: '프리미엄 구역',
      general: '일반 구역',
      quiet: '조용한 구역',
    };
    return labels[zoneType] || zoneType;
  }

  /**
   * 전체 좌석 통계 계산
   */
  calculateOverallStats(zones: ZoneSummary[]): OverallSeatStats {
    const totalSeats = zones.reduce((sum, zone) => sum + (zone.total_seats || 0), 0);
    const totalAvailable = zones.reduce((sum, zone) => sum + (zone.available_seats || 0), 0);
    const totalOccupied = zones.reduce((sum, zone) => sum + (zone.occupied_seats || 0), 0);
    const overallOccupancy = totalSeats > 0 ? Math.round((totalOccupied / totalSeats) * 100) : 0;

    return {
      totalSeats,
      totalAvailable,
      totalOccupied,
      overallOccupancy,
    };
  }

  /**
   * 전체 점유율 색상 클래스 반환
   */
  getOverallOccupancyColorClass(occupancy: number): string {
    return occupancy >= 80 ? 'text-red-600' : 'text-gray-900';
  }

  /**
   * 추가 요금 포맷팅
   */
  formatSurcharge(amount: number | undefined): string {
    if (amount === undefined || amount === null) {
      return '₩0';
    }
    const sign = amount > 0 ? '+' : '';
    return `${sign}₩${amount.toLocaleString()}`;
  }

  /**
   * 구역에 추가 요금이 있는지 확인
   */
  hasAnySurcharge(hourly: number | undefined, daily: number | undefined): boolean {
    return (hourly || 0) !== 0 || (daily || 0) !== 0;
  }
}

export const zoneSeatSummaryService = new ZoneSeatSummaryService();
